<template>
  <div id="menu-root">
    <b-navbar 
      id="nav-desktop"
      class="alinov-navbar" 
      fixed="top"
      variant="faded" 
      type="light" 
      v-bind:class="{'white-bg': isWhite, 'white-font': whiteFont}"
    >
      <b-navbar-brand>
        <b-img class="navbar-logo" :src="logoUrl" fluid />
      </b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-item v-bind:class="{'selected':currentRoute == 'home'}">
          <router-link to="/">Inicio</router-link>
        </b-nav-item>
        <b-nav-item v-bind:class="{'selected':currentRoute == 'about'}">
          <router-link to="/nosotros">Nosotros</router-link>
        </b-nav-item>
        <b-nav-item-dropdown text="Soluciones" right  v-bind:class="{'selected':currentRoute == 'syrups'}">
          <b-dropdown-item>
            <router-link to="/agrícola">Agrícola</router-link>
          </b-dropdown-item>
          <!--<b-dropdown-item>
            <router-link to="/agroinsumos">Agroinsumos</router-link>
          </b-dropdown-item>-->
          <b-dropdown-item>
            <router-link to="/nutrición">Nutrición animal</router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item v-bind:class="{'selected':currentRoute == 'kolectiva'}">
          <router-link to="/kolectiva"><h6 style="color:blue;">KOLECTIVA</h6></router-link>
        </b-nav-item>
        <b-nav-item v-bind:class="{'selected':currentRoute == 'contact'}">
          <router-link to="/contacto">Contacto</router-link>
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>


    <b-navbar 
      class="alinov-navbar white-bg" 
      id="nav-mobile" 
      toggleable 
      type="light" 
      variant="light"
      fixed="top"
    >
      <b-navbar-toggle target="nav_text_collapse" />

      <b-navbar-brand>
        <b-img class="navbar-logo" :src="logoUrl" fluid />
      </b-navbar-brand>

      <b-collapse is-nav id="nav_text_collapse">
        <b-navbar-nav>
          <b-nav-item v-bind:class="{'selected':currentRoute == 'home'}">
            <router-link to="/">Inicio</router-link>
          </b-nav-item>
          <b-nav-item v-bind:class="{'selected':currentRoute == 'about'}">
            <router-link to="/nosotros">Nosotros</router-link>
          </b-nav-item>
          <b-nav-item-dropdown text="Soluciones" right  v-bind:class="{'selected':currentRoute == 'syrups'}">
          <b-dropdown-item>
            <router-link to="/agrícola">Agrícola</router-link>
          </b-dropdown-item> 
            <b-dropdown-item>
              <router-link to="/kolectiva">KOLECTIVA</router-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link to="/nutrición">Nutrición</router-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-bind:class="{'selected':currentRoute == 'contact'}">
            <router-link to="/contacto">Contacto</router-link>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: ['isWhite', 'whiteFont'],
  computed: {
    currentRoute() {
        return this.$route.name;
    }
  },
  data() {
    return {
      logoUrl: require('../assets/images/logo.png')
    }
  }
};

</script>

<style lang="scss">

@media only screen and (max-width: 414px) {
  #nav-desktop {
    display: none;
  }

  .navbar-logo {
    width: 80px;
  }
}

@media only screen and (min-width: 415px) {
  #nav-mobile {
    display: none;
  }

  .navbar-logo {
    width: 120px;
  }
}

.dropdown-menu .dropdown-item:focus {
  outline: none !important; 
  background-color: #FFFFFF !important;
}

.alinov-navbar .dropdown-menu {
  border-radius: 0;

  .dropdown-item {

    a {
      color: #464242;
    }

    a:focus, a:hover {
      text-decoration: none;
      color: #007CC2;
      outline: none;
    }
  }
}

.alinov-navbar.navbar.navbar-light.white-bg {
  background-color: #F7F8FA;

  .navbar-nav .nav-item .nav-link {
    color: #464242;
    border-bottom: solid 1px rgba(0,0,0,0);

    &:hover, &:focus {
      color: #464242;
      border-bottom-color: #464242;
    }
  }
}

.alinov-navbar.navbar.navbar-light.white-font {
  a.dropdown-toggle {
    color: #FFFFFF;

    &:hover, &:focus {
      color: #FFFFFF;
      border-bottom-color: #FFFFFF;
    }
  }

  .navbar-nav .nav-item .nav-link {
    a {
      color: #FFFFFF;
    }
    border-bottom: solid 1px rgba(0,0,0,0);

    a:hover, a:focus {
      color: #FFFFFF;
      border-bottom-color: #FFFFFF;
    }
  }

  .navbar-nav .nav-item.selected .nav-link {
    color: #FFFFFF;
    border-bottom-color: #FFFFFF;
  }
}

.alinov-navbar:not(#nav-mobile).navbar.navbar-light {
  padding: 0.5rem 7rem;
  font-size: 14px;
}

.alinov-navbar.navbar.navbar-light {
  .navbar-brand {
    padding-top: 0;
    padding-bottom: 0;
  }

  a.dropdown-toggle {
    color: #464242;

    &:hover, &:focus {
      color: #464242;
      border-bottom-color: #464242;
    }
  }

  .navbar-nav .nav-item .nav-link {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    border-bottom: solid 1px rgba(0,0,0,0);

    a, a:hover, a:focus {
      color: #464242;
      border-bottom-color: #464242;
      text-decoration: none;
    }
  }

  .navbar-nav .nav-item.selected .nav-link {
    color: #464242;
    border-bottom-color: #464242;
  }

  .router-link-exact-active.router-link-active:hover {
    text-decoration: none;
  }
}

</style>
